module.exports = __webpack_public_path__ + "static/media/aspect_ratio.ae43fd93.svg";